import React, { useEffect, useState } from 'react';
import AuthContext from './auth/AuthContext';
import { SButton, SSubtitle, STitleContainer, STitleH3 } from './common/BCommonComponents';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { RiAddFill } from 'react-icons/ri';
import { Grid, Table, TableBody, TableContainer, TableRow } from '@material-ui/core';
import { HeadCell, STableHead } from './common/ScrivaniaTable';
import TableHead from '@material-ui/core/TableHead';
import { ActivityStatus, ContattoDTO, ContattoPrestazione, PrestazioneConfigDTO, PrestazioneDTO, TipoPrestazione } from './common/Dtos';
import { InserimentoPrestazioneDialog } from './InserimentoPrestazioneDialog';
import { PrestazioneContattoRow } from './prestazioniTable/PrestazioneContatto';
import { Location } from 'history';
import RouteLeavingGuard from './RouteLivingGuard';
import { SpinnerMuiContext } from './common/SpinnerMui';
import { dateToIsoMantainTime } from './common/DateUtils';

type ContattoParameters = {
	tipo: string,
	id: string
}

export function Contatto() {
	const auth = React.useContext(AuthContext);
	const spinner = React.useContext(SpinnerMuiContext);
	const history = useHistory();
	const param = useParams<ContattoParameters>();
	const [openDialog, setOpenDialog] = useState(false);

	const [contatto, setContatto] = useState<ContattoDTO>({
		id: '',
		operatore: '',
		tipoContatto: '',
		paziente: '',
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		puntoServizioId: '',
		cooperativaId: ''
	})
	// const [prestazioni, setPrestazioni] = useState<PrestazioneDTO[]>([]);
	const [contattoPrestazioni, setContattoPrestazioni] = useState<ContattoPrestazione[]>([]);
	const [concluso, setConcluso] = useState<boolean>(false);

	const tipoContatto = param.tipo.toLowerCase() === "callcenter" ? 'Call Center'
		: param.tipo.toLowerCase() === 'frontoffice' ? 'FrontOffice' : 'Mail';

	const headCells: HeadCell[] = [
		{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: false},
		{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE', sortable: true},
		{id: 'prestazione', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
		{id: 'descrizione', numeric: false, disablePadding: true, label: 'DESCRIZIONE', sortable: true},
		{id: 'paziente', numeric: false, disablePadding: true, label: 'PAZIENTE', sortable: true},
		{id: '', numeric: false, disablePadding: true, label: 'DURATA', sortable: true}
	];

	useEffect(() => {
		getContatto();
	}, []);

	useEffect(() => {
		if (concluso) {
			window.onbeforeunload = null;
		} else {
			window.onbeforeunload = (event: BeforeUnloadEvent) => {
				return "Attenzione! Il contatto non è ancora concluso! Confermi di voler uscire dalla pagina (non sarà possibile concludere il contatto in seguito)?";
			}
		}
		// }, [prestazioni, concluso, contattoPrestazioni]);
	}, [concluso, contattoPrestazioni]);

	const getContatto = () => {
		auth.state.axiosInstance?.get('/api/contatto/' + param.id)
			.then(res => {
				setContatto(res.data);
				// setPrestazioni(res.data.prestazioni)
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			});
	}

	const handleDialogOpen = () => {
		// controllo se e' presente una prestazione con data fine non compilata
		if (contattoPrestazioni && contattoPrestazioni.find(prest => prest.prestazione.status !== ActivityStatus.OK && prest.prestazione.status !== ActivityStatus.KO)) {
			// if (prestazioni && prestazioni.find(prest => prest.status !== ActivityStatus.OK && prest.status !== ActivityStatus.KO)) {
			toast.warning('Terminare tutte le prestazioni prima di aggiungerne una nuova!');
		} else {
			setOpenDialog(true);
		}
	}

	const handleDialogClose = (prestazioneDTO?: PrestazioneConfigDTO) => {
		if (prestazioneDTO) {
			const prestazione = {
				id: prestazioneDTO.id,
				name: prestazioneDTO.name,
				codice: prestazioneDTO.codice,
				description: prestazioneDTO.description,
				type: TipoPrestazione.FRONTOFFICE,
				idContatto: param.id,
				cooperativa: auth.state.cooperativa,
				tipoFrontOffice: param.tipo.toUpperCase(),
				puntoServizioId: auth.state.puntoServizioLogged?.id,
				codiceFiscalePersona: prestazioneDTO.codiceFiscalePersona,
				nomePersona: prestazioneDTO.nomePersona,
				cognomePersona: prestazioneDTO.cognomePersona,
				dataNascitaPersona: prestazioneDTO.dataNascitaPersona !== '' ? dateToIsoMantainTime(prestazioneDTO.dataNascitaPersona) : '',
				sessoPersona: prestazioneDTO.sessoPersona,
				nre: prestazioneDTO.nre,
				numeroPrenotazione: prestazioneDTO.numeroPrenotazione
			};
			axios.all([
				auth.state.axiosInstance?.post('/api/prestazione/insert', prestazione),
				auth.state.axiosInstance?.get('/api/prestazione/boOpzionali/' + prestazioneDTO.id)
			])
				.then(axios.spread((res1, res2) => {
					let newPrest: ContattoPrestazione[] = [];
					if (contattoPrestazioni && contattoPrestazioni.length > 0) {
						newPrest = [...contattoPrestazioni];
					}
					const contPrest: ContattoPrestazione = {
						prestazione: res1?.data,
						backofficeOpzionali: res2?.data
					}
					newPrest.unshift(contPrest);
					setContattoPrestazioni(newPrest);
					if (res1?.data.cupUrlRedirect != null) {
						window.open(res1?.data.cupUrlRedirect, '_blank', 'noopener,noreferrer');
					}
				})).catch(error => {
				toast.error('🛑 Errore durante l\'inserimento della prestazione!');
				console.log(error);
			});
		}
		setOpenDialog(false);
	}

	const handleEsitoPrestazione = (prestazione: PrestazioneDTO) => {
		spinner.setShowSpinner(true);
		auth.state.axiosInstance?.put('/api/prestazione/update/' + prestazione.id, prestazione)
			.then(res => {
				let newContPres = [...contattoPrestazioni];
				const index2 = newContPres.findIndex(p => p.prestazione.id === res.data.id);
				newContPres[index2].prestazione = res.data;
				setContattoPrestazioni(newContPres);
				spinner.setShowSpinner(false);
				toast.success('Prestazione terminata con successo!');
			})
			.catch(error => {
				spinner.setShowSpinner(false);
				toast.error('🛑 Errore durante l\'operazione!');
				console.log(error);
			});
	}

	const handleConcludiContatto = () => {
		if (contattoPrestazioni && contattoPrestazioni.find(prest => prest.prestazione.status === ActivityStatus.WAIT)) {
			toast.warning('Prima di concludere il contatto tutte le prestazioni devono essere terminate!');
		} else {
			auth.state.axiosInstance?.put('/api/contatto/concludi_contatto/' + param.id)
				.then(res => {
					setConcluso(true);
					toast.success('Contatto concluso con successo!');
					history.push('/dashboard');
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'operazione!');
					console.log(error);
				});
		}
	}

	const onStartTimer = (prestazione: PrestazioneDTO) => {
		//nothing
	}

	const onStopTimer = (prestazione: PrestazioneDTO) => {
		//nothing
	}

	const navigate = (path: string) => {
		//nothing
	}

	const shouldBlockNavigation = (location: Location): boolean => {
		return !concluso;
	}

	return (
		<div>
			<STitleContainer>
				<STitleH3>NUOVO CONTATTO</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100">
				<Grid item xs={12} className="pr-2">
					<SButton className="float-right" disabled={concluso} onClick={handleConcludiContatto}>CONCLUDI CONTATTO</SButton>
				</Grid>
			</Grid>
			<STitleContainer className="mt-0">
				<STitleH3 className="mt-3">PRESTAZIONI</STitleH3>
			</STitleContainer>
			<SButton className="mb-3" disabled={concluso} onClick={handleDialogOpen}><RiAddFill className="mr-2"/>Aggiungi</SButton>
			<TableContainer>
				<Table
					aria-labelledby="tableTitle"
					size={'medium'}
					aria-label="enhanced table"
				>
					<TableHead>
						<TableRow>
							{headCells.map((headCell) => (
								<STableHead
									key={headCell.id}
									align={headCell.numeric ? 'right' : 'left'}
									padding={headCell.disablePadding ? 'none' : 'default'}
								>
									{headCell.label}
								</STableHead>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{contattoPrestazioni &&
							contattoPrestazioni.map((row, index) => {
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<PrestazioneContattoRow
										key={row.prestazione.id}
										row={row.prestazione}
										labelid={labelId}
										onEsitoOk={handleEsitoPrestazione}
										isBackoffice={false}
										onStartTimer={onStartTimer}
										onStopTimer={onStopTimer}
										disabled={false}
										disabledTimer={false}
										idContatto={param.id}
										backofficeOpzionali={row.backofficeOpzionali}
									/>
								);

							})}
					</TableBody>
				</Table>
			</TableContainer>
			<InserimentoPrestazioneDialog open={openDialog} onClose={handleDialogClose} tipoContatto={TipoPrestazione.FRONTOFFICE}/>
			<RouteLeavingGuard
				when={true}
				navigate={navigate}
				shouldBlockNavigation={shouldBlockNavigation}
				message={"Prima di uscire dalla pagina concludere il contatto!"}
			/>
		</div>
	);
}
